module.exports = __webpack_public_path__ + "static/img/图层67.43711d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层67.png
// module id = CEOR
// module chunks = 0